module.exports = __webpack_public_path__ + "img/brand_popup_bg02.aa10495.a67881d0.png";